import React, { useEffect, useMemo, useState } from "react";
import investorService from "../../shared/api/investorService";

const pick = (obj, ...keys) => {
  for (const key of keys) {
    if (obj && obj[key] !== undefined && obj[key] !== null && obj[key] !== "") return obj[key];
  }
  return null;
};

const text = (value) => (value === null || value === undefined || String(value).trim() === "" ? "-" : String(value));
const number = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};
const money = (value) => {
  if (value === null || value === undefined || value === "") return "₹0";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
};
const dateText = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("en-IN");
};

const styles = {
  page: { color: "#F9FAFB", padding: "24px", minHeight: "100vh", background: "#0B1120" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, marginBottom: 24 },
  title: { fontSize: 30, fontWeight: 900, margin: 0 },
  subtitle: { color: "#94A3B8", marginTop: 6, fontSize: 14 },
  button: { background: "linear-gradient(135deg, #6366F1, #4F46E5)", color: "white", border: "none", padding: "10px 18px", borderRadius: 10, cursor: "pointer", fontWeight: 800, boxShadow: "0 12px 28px rgba(79,70,229,0.25)" },
  secondaryButton: { background: "#334155", color: "#F8FAFC", border: "1px solid #475569", padding: "10px 18px", borderRadius: 10, cursor: "pointer", fontWeight: 800 },
  alert: { background: "rgba(239,68,68,0.12)", color: "#FECACA", border: "1px solid rgba(239,68,68,0.25)", padding: "12px 14px", borderRadius: 12, marginBottom: 16 },
  summaryGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 14, marginBottom: 20 },
  stat: { background: "linear-gradient(135deg, #111827, #0F172A)", border: "1px solid #243244", borderRadius: 16, padding: 18 },
  statLabel: { color: "#94A3B8", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 900 },
  statValue: { color: "#F8FAFC", fontSize: 22, fontWeight: 900, marginTop: 8 },
  sourcePill: { display: "inline-flex", padding: "5px 10px", borderRadius: 999, background: "rgba(34,211,238,0.12)", color: "#67E8F9", fontSize: 12, fontWeight: 900, marginTop: 10 },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(310px, 1fr))", gap: 18, marginBottom: 26 },
  card: { background: "linear-gradient(135deg, #152033, #0F172A)", border: "1px solid #334155", borderRadius: 16, padding: 18, boxShadow: "0 16px 36px rgba(0,0,0,0.22)" },
  cardTop: { display: "flex", justifyContent: "space-between", gap: 14, alignItems: "flex-start", marginBottom: 14 },
  name: { fontSize: 18, fontWeight: 900, color: "#F8FAFC", margin: 0 },
  code: { display: "inline-flex", padding: "5px 9px", borderRadius: 8, background: "rgba(99,102,241,0.18)", color: "#A5B4FC", fontSize: 12, fontWeight: 900, marginTop: 8 },
  muted: { color: "#94A3B8", fontSize: 13, marginTop: 5 },
  row2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, margin: "14px 0" },
  mini: { background: "rgba(15,23,42,0.88)", border: "1px solid #243244", borderRadius: 12, padding: 12 },
  miniLabel: { color: "#94A3B8", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 900 },
  miniValue: { color: "#F8FAFC", fontSize: 15, fontWeight: 900, marginTop: 5 },
  status: { display: "inline-flex", alignItems: "center", padding: "5px 10px", borderRadius: 999, fontSize: 12, fontWeight: 900 },
  actions: { display: "flex", gap: 10, marginTop: 14 },
  panel: { background: "#0F172A", border: "1px solid #334155", borderRadius: 18, padding: 20, marginTop: 18, marginBottom: 26 },
  panelHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, marginBottom: 18 },
  panelTitle: { margin: 0, fontSize: 24, fontWeight: 900 },
  infoGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 14, marginBottom: 18 },
  infoCard: { background: "#111827", border: "1px solid #243244", borderRadius: 14, padding: 16 },
  infoTitle: { fontWeight: 900, color: "#E5E7EB", marginBottom: 10 },
  detailRow: { display: "flex", justifyContent: "space-between", gap: 14, padding: "9px 0", borderBottom: "1px solid #1F2937" },
  key: { color: "#94A3B8", fontSize: 13, fontWeight: 800 },
  val: { color: "#F8FAFC", fontSize: 13, fontWeight: 800, textAlign: "right", maxWidth: "58%", overflowWrap: "anywhere" },
  tableWrap: { background: "#111827", border: "1px solid #243244", borderRadius: 14, overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { color: "#CBD5E1", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.08em", textAlign: "left", padding: "14px 16px", borderBottom: "1px solid #243244", whiteSpace: "nowrap" },
  td: { color: "#F8FAFC", padding: "14px 16px", borderBottom: "1px solid #243244", whiteSpace: "nowrap", fontSize: 14 },
  empty: { background: "#111827", border: "1px dashed #334155", borderRadius: 16, padding: 28, color: "#94A3B8", textAlign: "center" },
  trend: { background: "#0F172A", border: "1px solid #243244", borderRadius: 16, padding: 16, marginBottom: 22 },
  trendTitle: { fontWeight: 900, marginBottom: 12 },
  bars: { display: "flex", alignItems: "flex-end", gap: 12, height: 110, overflowX: "auto" },
  barWrap: { minWidth: 64, textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 6 },
  bar: { width: 28, borderRadius: "8px 8px 2px 2px", background: "#157a5b" },
  barText: { fontSize: 11, color: "#CBD5E1", fontWeight: 800 },
  loading: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.38)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, color: "white", fontWeight: 900 },
};

const statusStyle = (status) => {
  const s = String(status || "").toUpperCase();
  if (s.includes("ACTIVE") || s.includes("VERIFIED") || s.includes("RUNNING") || s.includes("ASSIGNED")) return { ...styles.status, background: "rgba(34,197,94,0.15)", color: "#86EFAC" };
  if (s.includes("PENDING") || s.includes("SUBMITTED")) return { ...styles.status, background: "rgba(245,158,11,0.16)", color: "#FCD34D" };
  if (s.includes("INACTIVE") || s.includes("REJECT")) return { ...styles.status, background: "rgba(239,68,68,0.14)", color: "#FCA5A5" };
  return { ...styles.status, background: "rgba(148,163,184,0.14)", color: "#CBD5E1" };
};

const StatCard = ({ label, value }) => (
  <div style={styles.stat}>
    <div style={styles.statLabel}>{label}</div>
    <div style={styles.statValue}>{value}</div>
  </div>
);

const DetailRow = ({ label, value }) => (
  <div style={styles.detailRow}>
    <div style={styles.key}>{label}</div>
    <div style={styles.val}>{text(value)}</div>
  </div>
);

const Trend = ({ rows }) => {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  const max = Math.max(...rows.map((r) => number(r.amount)), 1);
  return (
    <div style={styles.trend}>
      <div style={styles.trendTitle}>Investment Trend</div>
      <div style={styles.bars}>
        {rows.map((row, index) => {
          const amount = number(row.amount);
          return (
            <div style={styles.barWrap} key={`${row.month || index}-${index}`}>
              <div style={styles.barText}>{money(amount)}</div>
              <div className="investor-trend-bar" style={{ ...styles.bar, minHeight: 8, height: Math.max(8, Math.round((amount / max) * 82)) }} />
              <div style={styles.barText}>{text(row.month)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default function InvestorManagementPage() {
  const [summary, setSummary] = useState({ investors: [], investmentTrend: [] });
  const [investors, setInvestors] = useState([]);
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadAll = async () => {
    setLoading(true);
    setError(null);
    try {
      let data;
      try {
        data = await investorService.getLinkedInvestorSummary();
      } catch (summaryError) {
        console.warn("Linked investor summary failed, falling back:", summaryError);
        const fallback = await investorService.getAllInvestors();
        data = { source: "old-backend-local", investors: fallback, totalInvestors: fallback.length, investmentTrend: [] };
      }
      const list = Array.isArray(data?.investors) ? data.investors : [];
      setSummary(data || {});
      setInvestors(list);
      if (selectedInvestor) {
        const refreshed = list.find((item) => investorIdOf(item) === investorIdOf(selectedInvestor));
        if (refreshed) setSelectedInvestor(refreshed);
      }
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to load linked investors.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const investorIdOf = (investor) => pick(investor, "investorId", "id", "investor_id");

  const openDetails = async (investor) => {
    const id = investorIdOf(investor);
    setSelectedInvestor(investor);
    setInvestments(Array.isArray(investor.investments) ? investor.investments : []);
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const rows = await investorService.getInvestmentsByInvestor(id);
      setInvestments(Array.isArray(rows) ? rows : []);
    } catch (err) {
      console.warn("Investment API failed, using summary investments:", err);
      setInvestments(Array.isArray(investor.investments) ? investor.investments : []);
    } finally {
      setLoading(false);
    }
  };

  const sourceLabel = summary.source === "new-investor-backend" ? "Linked with new investor backend" : "Old backend fallback";

  const totals = useMemo(() => ({
    totalInvestors: number(summary.totalInvestors ?? investors.length),
    totalInvested: number(summary.totalInvested ?? summary.totalPackageInvested),
    investmentCount: number(summary.investmentCount),
    activeInvestmentCount: number(summary.activeInvestmentCount),
  }), [summary, investors]);

  const investmentAmountOf = (inv) => pick(inv, "investmentAmount", "investment_amount", "amount");
  const packageNameOf = (inv) => pick(inv, "packageName", "package_name", "packageNameSnapshot", "package_name_snapshot");
  const investmentDateOf = (inv) => pick(inv, "investmentDate", "selectedAt", "selected_at", "createdAt", "created_at");

  return (
    <div className="investor-page" style={styles.page}>
      {error && <div style={styles.alert}>{error}</div>}

      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Investor Management</h1>
          <div style={styles.subtitle}>Investors, packages and investment values are now pulled from the integrated backend.</div>
          <span style={styles.sourcePill}>{sourceLabel}</span>
        </div>
        <button style={styles.button} onClick={loadAll}>Refresh Linked Data</button>
      </div>

      <div style={styles.summaryGrid}>
        <StatCard label="Total Investors" value={totals.totalInvestors.toLocaleString("en-IN")} />
        <StatCard label="Total Invested" value={money(totals.totalInvested)} />
        <StatCard label="Investment Count" value={totals.investmentCount.toLocaleString("en-IN")} />
        <StatCard label="Active Investments" value={totals.activeInvestmentCount.toLocaleString("en-IN")} />
      </div>

      <Trend rows={summary.investmentTrend} />

      {investors.length === 0 ? (
        <div style={styles.empty}>No linked investors found. Check the old backend integration config and investor_module_db connection.</div>
      ) : (
        <div style={styles.grid}>
          {investors.map((investor) => {
            const id = investorIdOf(investor);
            const totalInvested = pick(investor, "totalInvested", "investmentAmount", "total_invested");
            const packageNames = pick(investor, "packageNames", "package_names", "preferredPlan");
            return (
              <div style={styles.card} key={id || investor.email || investor.mobile}>
                <div style={styles.cardTop}>
                  <div>
                    <h3 style={styles.name}>{text(pick(investor, "fullName", "name", "full_name"))}</h3>
                    <div style={styles.muted}>{text(investor.email)}</div>
                    <div style={styles.muted}>{text(pick(investor, "mobile", "phone"))}</div>
                    <span style={styles.code}>{text(pick(investor, "investorCode", "investor_code") || (id ? `INV-${String(id).padStart(4, "0")}` : "-"))}</span>
                  </div>
                  <span style={statusStyle(investor.status)}>{text(investor.status || "ACTIVE")}</span>
                </div>

                <div style={styles.muted}>Package Link</div>
                <div style={{ color: "#E5E7EB", fontWeight: 900, marginTop: 4, overflowWrap: "anywhere" }}>{text(packageNames)}</div>

                <div style={styles.row2}>
                  <div style={styles.mini}>
                    <div style={styles.miniLabel}>Total Invested</div>
                    <div style={styles.miniValue}>{money(totalInvested)}</div>
                  </div>
                  <div style={styles.mini}>
                    <div style={styles.miniLabel}>Investments</div>
                    <div style={styles.miniValue}>{number(investor.investmentCount).toLocaleString("en-IN")}</div>
                  </div>
                  <div style={styles.mini}>
                    <div style={styles.miniLabel}>Expected Profit</div>
                    <div style={styles.miniValue}>{money(investor.expectedProfit)}</div>
                  </div>
                  <div style={styles.mini}>
                    <div style={styles.miniLabel}>Available Profit</div>
                    <div style={styles.miniValue}>{money(investor.availableProfit)}</div>
                  </div>
                </div>

                <div style={styles.actions}>
                  <button style={styles.button} onClick={() => openDetails(investor)}>View Linked Details</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {selectedInvestor && (
        <div style={styles.panel}>
          <div style={styles.panelHeader}>
            <div>
              <h2 style={styles.panelTitle}>{text(pick(selectedInvestor, "fullName", "name", "full_name"))}</h2>
              <div style={styles.subtitle}>{text(pick(selectedInvestor, "investorCode", "investor_code"))} • Joined {dateText(selectedInvestor.joinDate || selectedInvestor.createdAt)}</div>
            </div>
            <button style={styles.secondaryButton} onClick={() => { setSelectedInvestor(null); setInvestments([]); }}>Close</button>
          </div>

          <div style={styles.infoGrid}>
            <div style={styles.infoCard}>
              <div style={styles.infoTitle}>Investor Basic</div>
              <DetailRow label="Investor ID" value={investorIdOf(selectedInvestor)} />
              <DetailRow label="Full Name" value={pick(selectedInvestor, "fullName", "name", "full_name")} />
              <DetailRow label="Status" value={selectedInvestor.status} />
              <DetailRow label="Source" value={selectedInvestor.sourceModule || summary.source} />
            </div>
            <div style={styles.infoCard}>
              <div style={styles.infoTitle}>Contact</div>
              <DetailRow label="Email" value={selectedInvestor.email} />
              <DetailRow label="Mobile" value={pick(selectedInvestor, "mobile", "phone")} />
              <DetailRow label="District" value={selectedInvestor.district} />
              <DetailRow label="State" value={selectedInvestor.state} />
            </div>
            <div style={styles.infoCard}>
              <div style={styles.infoTitle}>Investment Summary</div>
              <DetailRow label="Total Invested" value={money(pick(selectedInvestor, "totalInvested", "investmentAmount"))} />
              <DetailRow label="Investment Count" value={number(selectedInvestor.investmentCount).toLocaleString("en-IN")} />
              <DetailRow label="Active Count" value={number(selectedInvestor.activeInvestmentCount).toLocaleString("en-IN")} />
              <DetailRow label="Packages" value={pick(selectedInvestor, "packageNames", "preferredPlan")} />
            </div>
            <div style={styles.infoCard}>
              <div style={styles.infoTitle}>Profit</div>
              <DetailRow label="Expected Profit" value={money(selectedInvestor.expectedProfit)} />
              <DetailRow label="Available Profit" value={money(selectedInvestor.availableProfit)} />
              <DetailRow label="Investor %" value={selectedInvestor.investorProfitPer ? `${selectedInvestor.investorProfitPer}%` : "-"} />
              <DetailRow label="Founder %" value={selectedInvestor.founderProfitPer ? `${selectedInvestor.founderProfitPer}%` : "-"} />
            </div>
          </div>

          <div style={styles.tableWrap}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Code</th>
                  <th style={styles.th}>Package</th>
                  <th style={styles.th}>Amount</th>
                  <th style={styles.th}>Goats</th>
                  <th style={styles.th}>Expected Profit</th>
                  <th style={styles.th}>Available Profit</th>
                  <th style={styles.th}>Status</th>
                </tr>
              </thead>
              <tbody>
                {investments.length === 0 ? (
                  <tr><td style={styles.td} colSpan="8">No linked investments found for this investor.</td></tr>
                ) : (
                  investments.map((inv, index) => (
                    <tr key={pick(inv, "id", "investmentId", "investment_id") || index}>
                      <td style={styles.td}>{dateText(investmentDateOf(inv))}</td>
                      <td style={styles.td}>{text(pick(inv, "investmentCode", "investment_code"))}</td>
                      <td style={styles.td}>{text(packageNameOf(inv))}</td>
                      <td style={styles.td}>{money(investmentAmountOf(inv))}</td>
                      <td style={styles.td}>{text(pick(inv, "goatCount", "goat_count"))}</td>
                      <td style={styles.td}>{money(pick(inv, "expectedProfit", "expected_profit", "expectedMargin"))}</td>
                      <td style={styles.td}>{money(pick(inv, "availableProfit", "available_profit"))}</td>
                      <td style={styles.td}><span style={statusStyle(inv.status)}>{text(inv.status)}</span></td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {loading && <div style={styles.loading}>Loading linked backend data...</div>}
    </div>
  );
}
